import { css } from '@emotion/css';

const BUTTON_SIZE = 44;
const BUTTON_SIZE_MOBILE = 52;
const BORDER_RADIUS = 8;
const GAP = 8;
const GAP_MOBILE = 8;
const ICON_SIZE = 16;

export const mapToolbarStyles = {
  container: css`
    position: absolute;
    bottom: 22px;
    right: 0px;
    z-index: 1000;
    background: transparent;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: ${GAP}px;
    pointer-events: none;
  `,

  containerMobile: css`
    position: absolute;
    bottom: 40px;
    right: 0px;
    z-index: 1000;
    background: transparent;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: ${GAP_MOBILE}px;
    pointer-events: none;
  `,

  button: css`
    width: ${BUTTON_SIZE}px !important;
    height: ${BUTTON_SIZE}px !important;
    min-width: ${BUTTON_SIZE}px !important;
    max-width: ${BUTTON_SIZE}px !important;
    border-radius: ${BORDER_RADIUS}px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(12px);
    color: #666666;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow:
      0 2px 8px rgba(0, 0, 0, 0.12),
      0 1px 3px rgba(0, 0, 0, 0.08);
    position: relative;
    z-index: 1;
    margin: 0;
    padding: 0 !important;
    overflow: hidden;
    pointer-events: auto;

    &:hover:not(:disabled) {
      background: rgba(255, 255, 255, 1);
      transform: translateY(-1px);
      box-shadow:
        0 4px 12px rgba(0, 0, 0, 0.15),
        0 2px 4px rgba(0, 0, 0, 0.1);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none;
    }
  `,

  buttonMobile: css`
    width: ${BUTTON_SIZE_MOBILE}px !important;
    height: ${BUTTON_SIZE_MOBILE}px !important;
    min-width: ${BUTTON_SIZE_MOBILE}px !important;
    max-width: ${BUTTON_SIZE_MOBILE}px !important;
    font-size: 20px;
  `,

  deleteButtonActive: css`
    color: #ff4d4f;
  `,

  icon: css`
    font-size: ${ICON_SIZE}px;
    line-height: ${ICON_SIZE}px;
    width: ${ICON_SIZE}px;
    height: ${ICON_SIZE}px;
    display: block;
  `,
};
